import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>Confirmación</h2>
    <mat-dialog-content>¿Estás seguro de que deseas eliminar este vehículo?</mat-dialog-content>
    <mat-dialog-actions class="actions">
      <button mat-button color="warn" [mat-dialog-close]="true">Eliminar</button>
      <button mat-button mat-dialog-close="false">Cancelar</button>
    </mat-dialog-actions>
  `,
  styles: [`
    .actions {
      display: flex;
      justify-content: space-between;
    }
  `]
})
export class ConfirmDialogComponent {}
